export default "__VITE_ASSET__B$TP40td__"